<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        get menuList() {
            return {
                // container: "",
                list: [
                    {
                        key: aiStatusType.graphCompare,
                        label: this.$t("compare"),
                        img: "ai-chart-compare",
                    },
                    {
                        key: aiStatusType.graphAbnormal,
                        label: this.$t("error"),
                        img: "ai-chart-error",
                    },
                    {
                        key: aiStatusType.graphSummary,
                        label: this.$t("summarize"),
                        img: "ai-chart-summarize",
                    },
                    {
                        key: aiStatusType.graphPredict,
                        label: this.$t("trend"),
                        img: "ai-chart-trend",
                    },
                    {
                        key: aiStatusType.graphChat,
                        label: this.$t("more"),
                        img: "ai-menu-more",
                    },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        handleClicks(id) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                const ustr = this.menuList.list.filter((item) => item.key == id)[0].label;
                this.$bus.$emit("aiAnalyse", id, ustr, id == aiStatusType.graphChat);
                this.aiTrackData(id);
            });
            this.closeDrop();
        }
        get isTable() {
            return this.$store.state.shape.type == "Table";
        }
        aiTrackData(id) {
            let obj = {
                [aiStatusType.graphCompare]: "Chart Analysis-Data Comparison",
                [aiStatusType.graphAbnormal]: "Chart Analysis-Anomaly Identification",
                [aiStatusType.graphSummary]: "Chart Analysis-Summary",
                [aiStatusType.graphPredict]: "Chart Analysis-Trends Prediction",
                [aiStatusType.graphChat]: "Chart Analysis More",
            };
            let str = obj[id];
            if (this.isTable) {
                str.replace(/Chart/, "Table");
            }
            this.sensors.track("clickAItoolbar", {
                Catalogues: "AI",
                click_type: obj[id],
            });
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
        "compare": "数据对比",
        "error": "异常识别",
        "summarize": "概括总结",
        "trend": "趋势预测",
        "more": "更多"
  },
  "en": {
        "compare": "Data Comparison",
        "error": "Anomaly Identification",
        "summarize": "Summary",
        "trend": "Trends Prediction",
        "more": "More"
  },
  "fr": {
        "compare": "Comparaison des données",
        "error": "Identification des anomalies",
        "summarize": "Résumé",
        "trend": "Prédiction des tendances",
        "more": "Plus"
  },
  "de": {
        "compare": "Datenvergleich",
        "error": "Erkennung von Anomalien",
        "summarize": "Zusammenfassung",
        "trend": "Trendvorhersage",
        "more": "Mehr"
  },
  "jp": {
        "compare": "データ比較",
        "error": "異常の特定",
        "summarize": "まとめ",
        "trend": "トレンド予測",
        "more": "その他"
  },
  "es": {
        "compare": "Comparación de datos",
        "error": "Identificación de anomalías",
        "summarize": "Resumen",
        "trend": "Predicción de tendencias",
        "more": "Más"
  },
  "pt": {
        "compare": "Comparação de dados",
        "error": "Identificação de anomalia",
        "summarize": "Resumo",
        "trend": "Previsão de tendências",
        "more": "Mais"
  },
  "it": {
        "compare": "Confronto dei dati",
        "error": "Identificazione delle anomalie",
        "summarize": "Riepilogo",
        "trend": "Previsione tendenze",
        "more": "Altro"
  },
  "tw": {
        "compare": "資料比較",
        "error": "異常識別",
        "summarize": "摘要",
        "trend": "趨勢預測",
        "more": "更多"
  }
}
</i18n>
